import React from 'react';

import {useFeatures} from '@udemy/react-experimentation-provider';
import {serverOrClient} from '@udemy/shared-utils';

interface AuthAjaxModalProps {
    isOpen: boolean;
    onClose?: () => void;
    url: string;
    preloader?: () => void;
    className?: string;
}
const features = ['auth_full_page_redirect'];

export const AuthAjaxModal: React.FC<AuthAjaxModalProps> = (props) => {
    const {isOpen, url} = props;
    const {featureVariantAssignments} = useFeatures(features);
    const config = featureVariantAssignments.get('auth_full_page_redirect')?.configuration;

    return config?.renderAuthFullpage && isOpen ? (
        (() => {
            serverOrClient.global.location.href = url;
            return null;
        })()
    ) : (
        <></>
    );
};
